import React,{useState,useEffect,useContext} from 'react';
import PropTypes from 'prop-types';
import Checkbox  from './Checkbox';
import Context from "./auth/Context";
import isFunction  from 'lodash/isFunction';

function CheckboxList({ field,onChange,value,items,readOnly,codeField,titleField,showHeader,style,condition}) {
    let [data,setData] = useState(value||{});
    let [all,setAll] = useState(false);
    let [list,setList] = useState(isFunction(items)?[]:items);
    useEffect(()=>{
        setData(value||{})
    },[value])

    useEffect(()=>{
        (async ()=>{
            if(isFunction(items)){
                try{
                    let query;
                    if(condition){
                        if(condition.then){
                            query = await condition;
                        }else{
                            query = condition;
                        }
                    }
                    let rs =  await items(query);
                    setList(rs);
                }catch(e){
                    console.error(e);
                }
                
            }
        })().catch(e=>{
            console.error(e);
        }) 
    },[])

    
    let context = useContext(Context)
    
    const handleValueChanged =(item,_value)=>{
        if(readOnly) return;
        (list||[]).forEach(item=>{
            data[item[codeField||"code"]] = data[item[codeField||"code"]] || false;
        })
        data[item[codeField||"code"]] = _value;
        setData(data);
        if(onChange){
            onChange(data)
        }
    }
    const selectAll =(_value)=>{
        setAll(_value);
        (list||[]).forEach(item=>{
            data[item[codeField||"code"]] = _value;
        })
        for(let key in data){
            data[key] = _value;
        }
        setData(data);
        if(onChange){
            onChange(data)
        }
    }
    if(list.length==0) return null;
    return (
        <fieldset style={style||{borderRadius:5}}>{showHeader!=false && <legend>{field.header||""}</legend>}
            {(list||[]).map(item=>{
                return (
                    <Checkbox  key={item[codeField||"code"]}
                        label={context.apis.getLabel(item[titleField||"title"])} 
                        disabled={readOnly} 
                        readOnly = {readOnly} 
                        value={data[item[codeField||"code"]]} 
                        onChange={(event)=>handleValueChanged(item,event.target.checked)}/>
                )
            })}
            {!readOnly && <Checkbox
                label={context.apis.getLabel("Tất cả")} 
                value={all} 
                onChange={(event)=>selectAll(event.target.checked)}/>}

        </fieldset>
    );
}
CheckboxList.propTypes={
    field:PropTypes.any,
    value:PropTypes.object,
    items:PropTypes.any,
    onChange:PropTypes.func,
    readOnly:PropTypes.bool,
    codeField:PropTypes.string,
    titleField:PropTypes.string,
    showHeader:PropTypes.bool,
    style:PropTypes.any,
    condition:PropTypes.any,
}
export default CheckboxList;